import { getNoteChromaticIndex, MelodyLib } from '@tunasong/music-lib'
import type { NoteName, Scale } from '@tunasong/schemas'

/**
 * The notes a melody may use over a chord: the note set, `MelodyLib.chordNoteSet` (Bowie's ruling, GH #2934). Every
 * chord tone, plus the scale's notes on the letters the chord leaves free. Over E7 in C that brings in G♯ and drops G;
 * over B♭ in C it drops B♮, which clashes with the root.
 *
 * One definition, shared with the roll's theory cues, so the server and the cues agree on what is chromatic. Chord
 * tones come first, root first; then the scale's other notes. An unknown chord gives the scale.
 */
export const chordScale = (symbol: string, scale: Scale): NoteName[] => MelodyLib.chordNoteSet(symbol, scale)

/** `chordScale` as pitch classes, 0 (C) to 11 (B) */
export const chordScalePitchClasses = (symbol: string, scale: Scale) =>
  new Set(chordScale(symbol, scale).map(name => getNoteChromaticIndex(name)))
